import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// 園藝測驗題庫（可彈性擴充）
const gardenQuiz = [
  {
    title: "【你家的「造景」，是黴菌偷偷開派對的秘密森林嗎？】",
    subtitle: "盆土",
    image: process.env.PUBLIC_URL + "/img/garden-quiz1.webp",
    points: [
      { x: 35, y: 35, correct: true },  // 藍點（正確）
      { x: 20, y: 20, correct: false }, // 紅點
      { x: 75, y: 85, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🌱盆栽土壤已經不是乾淨的泥土了！黴菌在上面鋪了一層白毯啦～你是不是天天澆水但土都沒翻動過？或是把植物養在通風差的地方？👀 盆土長時間濕漉的、不曬太陽，黴菌就超愛！",
        "最常見的有青黴菌、枝孢菌、毛黴菌，會讓土表出現白毛、黑斑或灰色黏膜狀黴層。這些黴菌不只會影響植物健康，孢子還可能飄到室內，引發過敏、氣喘、眼痒鼻癢症狀！",
        "✅盆土防霉三招：",
        "1. 澆水量要控制，避免盆土長期濕濕黏黏！💧",
        "2. 放在通風、光照良好的地方，定期翻鬆表層土！☀️",
        "3. 可灑些肉桂粉、活性碳粉，自然抗菌防霉！"
      ]
    }
  },
  {
    title: "【你家的「造景」，是黴菌偷偷開派對的秘密森林嗎？】",
    subtitle: "花盆",
    image: process.env.PUBLIC_URL + "/img/garden-quiz2.webp",
    points: [
      { x: 40, y: 50, correct: true },  // 藍點（正確）
      { x: 15, y: 20, correct: false }, // 紅點
      { x: 75, y: 85, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🌿花盆也是受災戶！？黴菌可能早就從底部往上蔓延啦～你是不是花盆一直放在托盤積水裡？還有用塑膠盆但從沒洗過？👀 花盆內壁、水孔邊、底部都可能因濕氣和殘留物孳生黴菌！",
        "常見黴菌有枝孢菌、麴菌、青黴菌，特別是陶盆與塑膠盆表面會冒出白色或黑點斑斑，看起來像髒污但其實是活生生的黴菌殖地！",
        "✅花盆防霉三招：",
        "1. 盆底排水孔要保持暢通，托盤不能長時間積水！💦",
        "2. 換土或換植物時，把花盆內外徹底刷洗、曬乾再用！🧽",
        "3. 避免用報紙或濕布蓋土面，那會鎖住濕氣助長黴菌！🚫"
      ]
    }
  },
  {
    title: "【你家的「造景」，是黴菌偷偷開派對的秘密森林嗎？】",
    subtitle: "澆花器",
    image: process.env.PUBLIC_URL + "/img/garden-quiz3.webp",
    points: [
      { x: 50, y: 40, correct: true },  // 藍點（正確）
      { x: 30, y: 20, correct: false }, // 紅點
      { x: 50, y: 80, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "💦澆花器不是用清水就安全！黴菌可能早就在噴嘴裡結網啦～你是不是每次澆完水就把澆花器隨手一放？長期沒洗過內部或噴頭？👀 裡面積水、黏液、植物殘渣沒清乾淨，黴菌就會悄悄爬進去！",
        "常見黴菌有麴菌、青黴菌，不僅讓水變臭、出現黏膜，還可能隨水噴到植物或室內物品上，導致植物生病！",
        "✅澆花器防霉三招：",
        "1. 澆完水要倒乾＋開口向下晾乾，不能悶著放！⏳",
        "2. 每週用溫水＋小蘇打粉清洗內壁與噴嘴！🧴",
        "3. 避免長期儲水不更換，特別是透明瓶更要注意藻類與黴菌共生！👀"
      ]
    }
  },
  {
    title: "【你家的「造景」，是黴菌偷偷開派對的秘密森林嗎？】",
    subtitle: "裝飾品",
    image: process.env.PUBLIC_URL + "/img/garden-quiz4.webp",
    points: [
      { x: 63, y: 48, correct: true },  // 藍點（正確）
      { x: 25, y: 25, correct: false }, // 紅點
      { x: 65, y: 85, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🧸黴菌可能正偷偷在裝飾品上面畫地為王～你是不是在盆栽上放了小木牌、石頭、小動物裝飾，但從沒清理過？👀 天然材質（木片、竹片、椰纖、泥炭苔）吸水力強，一潮就霉！",
        "黴菌像枝孢菌、毛黴菌都很常見，會讓裝飾變色、長毛、冒黏絲狀黴層，嚴重還可能傳到植株本體！",
        "✅裝飾防霉三招：",
        "1. 天然裝飾要定期拿出來清洗＋曬太陽除濕！☀️",
        "2. 可選防霉處理過的塑膠、陶瓷裝飾品較耐用～🧠",
        "3. 避免直接壓住土表，留通氣空間避免悶霉！🌬️"
      ]
    }
  }
];

export default function Garden() {
  const [quizIdx, setQuizIdx] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [wrongClick, setWrongClick] = useState(false);
  const [done, setDone] = useState(false);
  const quiz = gardenQuiz[quizIdx];

  function handlePointClick(point) {
    if (point.correct) {
      setShowInfo(true);
    } else {
      setWrongClick(true);
      setTimeout(() => setWrongClick(false), 600);
    }
  }

  function handleNext() {
    if (quizIdx < gardenQuiz.length - 1) {
      setQuizIdx(quizIdx + 1);
      setShowInfo(false);
      setWrongClick(false);
    } else {
      setDone(true);
    }
  }

  const navigate = useNavigate();
  if (done) {
    return (
      <div className="garden-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 0 }}>
        <div style={{ maxWidth: 900, margin: '0 auto', background: 'none', borderRadius: 12, padding: 0, textAlign: 'center', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 700, margin: '48px 0 0 0', letterSpacing: 2 }}>太棒了！園藝篇結束</div>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
            <img src={process.env.PUBLIC_URL + '/img/finish.webp'} alt="Lulu thumbs up" style={{ width: 220, height: 220, objectFit: 'contain', background: '#444', borderRadius: 16 }} />
          </div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 18px 0', letterSpacing: 1 }}>恭喜你找到園藝中黴菌喜歡生長的地方！</div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 36px 0', letterSpacing: 1 }}>快去檢查看看你的植物中有沒有這些黴菌吧！</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: 48 }}>
            <button
              className="main-btn"
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
              onClick={() => navigate('/diagnosis')}
            >
              去檢查
            </button>
            <button 
              onClick={() => navigate('/main')} 
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
            >
              回首頁
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="garden-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 20 }}>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16 }}>
        <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
        <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
      </div>
      <div style={{ maxWidth: 900, margin: '0 auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: 24 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 8 }}>{quiz.title}</div>
            <div style={{ fontSize: '1.4rem', fontWeight: 500, marginBottom: 12 }}>{quiz.subtitle}</div>
            <div style={{ color: '#444', fontSize: '1rem', marginBottom: 8 }}>《點點看，黴菌在哪裡？》</div>
          </div>
          <img src={process.env.PUBLIC_URL + '/img/03.webp'} alt="Lulu" style={{ width: 120, height: 120, borderRadius: 14, background: '#eee' }} />
        </div>
        <div style={{ position: 'relative', margin: '24px auto', width: 340, height: 260 }}>
          <img
            src={quiz.image}
            alt="quiz"
            style={{ width: 340, height: 260, borderRadius: 10, objectFit: 'cover', border: '2px solid #bbb' }}
          />
          {quiz.points.map((p, idx) => (
            <div
              key={idx}
              onClick={() => handlePointClick(p)}
              style={{
                position: 'absolute',
                left: `calc(${p.x}% - 18px)`,
                top: `calc(${p.y}% - 18px)`,
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: p.correct ? '#ff2e2e' : '#ff2e2e',
                border: '3px solid #fff',
                boxShadow: wrongClick && !p.correct ? '0 0 12px 4px #ff2e2e' : '0 2px 8px #0003',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                zIndex: 2,
                display: showInfo && !p.correct ? 'none' : 'block',
              }}
              title={p.correct ? '正確答案' : '不是這裡'}
            />
          ))}
        </div>
        {showInfo && (
          <div style={{
            background: '#f8f8e8',
            borderRadius: 10,
            margin: '32px 0 0 0',
            padding: '24px 32px',
            boxShadow: '0 1px 6px #0001',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 24,
            border: '2px solid #b0e0e6'
          }}>
            <img src={quiz.info.luluImg} alt="Lulu" style={{ width: 60, height: 60, borderRadius: 10, marginRight: 16 }} />
            <div>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 8 }}>{quiz.info.title}</div>
              {quiz.info.content.map((line, i) => (
                <div key={i} style={{ fontSize: '1.08rem', marginBottom: 4 }}>{line}</div>
              ))}
            </div>
          </div>
        )}
        {showInfo && (
          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <button onClick={handleNext} style={{
              background: '#4caf50',
              color: '#fff',
              fontSize: '1.1rem',
              fontWeight: 600,
              padding: '10px 32px',
              border: 'none',
              borderRadius: 8,
              boxShadow: '0 2px 8px #0001',
              cursor: 'pointer',
              marginRight: 8
            }}>
              {quizIdx < gardenQuiz.length - 1 ? '下一題 →' : '完成'}
            </button>
          </div>
        )}
      </div>
  </div>);
}

